import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { cn } from "~/lib/utils";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { Tooltip } from "~/components/Tooltip";
import { AssetTableRowData } from "../types";

export const BANKRUPCY_REMOTE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    label: (
        <>
            Bankruptcy
            <br />
            Remote
        </>
    ),
    slug: "are_holdings_bankruptcy_remote",
    sortsOn: "are_holdings_bankruptcy_remote" as AssetColumns,
    tooltip:
        "Stablecoin is shielded from the risks and liabilities of the entity that issues the stablecoin. Holders have an enforceable right to underlying assets even in the case of issuer bankruptcy.",
    type: ColumnTypes.string,
    width: 150,
    loginRequired: true,
    render: (item) => {
        if (item.isAsset) {
            const {
                are_holdings_bankruptcy_remote,
                holdings_bankruptcy_remote_description,
            } = item;

            // Render Emdash if value is not true or false
            if (are_holdings_bankruptcy_remote === null) {
                return (
                    <div className="flex justify-center">
                        <Emdash />
                    </div>
                );
            }

            const icon = (
                <FontAwesomeIcon
                    icon={
                        are_holdings_bankruptcy_remote === true
                            ? faCheckCircle
                            : faTimesCircle
                    }
                    className={cn("h-4", {
                        "text-blue-400":
                            are_holdings_bankruptcy_remote === true,
                        "text-muted-foreground":
                            are_holdings_bankruptcy_remote !== true,
                    })}
                />
            );

            // Just render icon if description is empty / null
            if (
                holdings_bankruptcy_remote_description === null ||
                holdings_bankruptcy_remote_description?.trim() === ""
            ) {
                return <div className="w-full flex justify-center">{icon}</div>;
            }

            return (
                <Tooltip
                    placement="top"
                    tooltipContent={
                        <div className="w-max px-3">
                            <p className="py-1.5 text-sm max-w-120">
                                {holdings_bankruptcy_remote_description}
                            </p>
                        </div>
                    }
                >
                    {({ setTriggerRef }) => (
                        <div
                            className="w-full flex justify-center"
                            ref={setTriggerRef}
                        >
                            {icon}
                        </div>
                    )}
                </Tooltip>
            );
        }

        return (
            <div className="flex justify-center">
                <Emdash />
            </div>
        );
    },
};
